/*
	The following will search for all elements with a jdrf-load-more class
	Each of those elements will be setup to, on click, make ajax calls for more items
	Items will be added to the specified element ID (from attribute)
	details will be specified by the attributes

	Attributes:
		spinnerid    	-- The ID of an element which will show the spinner
		load_count	 	-- Number of items to get each time the button is pressed
		post_type	 	-- Post type of the items to get
		add_posts_to 	-- The ID of the element which the new items are added to
		template 	 	-- The template for adding an item

	Template is standard html with {{var}} replaced with the incoming information
		{{ID}}
		{{excerpt}}
		{{permalink}}
		{{post_date}}
		{{post_title}}
		{{post_type}}
		{{post_type_name}}
*/
const init = () => {
	const loadMoreUtility = ( jQuery, Backbone, _ ) => {

		var loadMoreGeneric = function ( element ) {
			this.element = element;
			this.doingAJAX = false;
			this.paged = 0;

			this.spinnerid = element.getAttribute( 'spinnerid' );
			this.spinner = ! _.isUndefined( this.spinnerid ) ? document.getElementById( this.spinnerid ) : undefined;

			this.addto = element.getAttribute( 'add_posts_to' );
			this.addtoElement = ! _.isUndefined( this.addto ) ? document.getElementById( this.addto ) : undefined;

			this.template = element.getAttribute( 'template' );
			this.templateElement = ! _.isUndefined( this.template ) ? document.getElementById( this.template ) : undefined;

			this.postType = element.getAttribute( 'post_type' );
			if ( _.isUndefined( this.postType ) ) { this.postType = 'post'; }

			this.postNotIn = element.getAttribute( 'post__not_in' );
			if ( _.isUndefined( this.postNotIn ) ) { this.postNotIn = ''; }

			this.postPerPage = element.getAttribute( 'load_count' );
			if ( _.isUndefined( this.postPerPage ) ) { this.postPerPage = 5; }

			this.taxonomy = element.getAttribute( 'taxonomy' );
			if ( _.isUndefined( this.taxonomy ) ) { this.taxonomy = ''; }

			this.termfield = element.getAttribute( 'termfield' );
			if ( _.isUndefined( this.termfield ) ) { this.termfield = ''; }

			this.terms = element.getAttribute( 'terms' );
			if ( _.isUndefined( this.terms ) ) { this.terms = ''; }

			this.pastEvents = element.getAttribute( 'past_events' );
			if ( _.isUndefined( this.pastEvents ) ) { this.pastEvents = null; }

			this.epIntegrate = element.getAttribute( 'ep_integrate' );
			if ( _.isUndefined( this.epIntegrate ) ) { this.epIntegrate = null; }

			this.metaKey = element.getAttribute( 'meta_key' );
			if ( _.isUndefined( this.epIntegrate ) ) { this.epIntegrate = null; }

			this.metaValue = element.getAttribute( 'meta_value' );
			if ( _.isUndefined( this.epIntegrate ) ) { this.epIntegrate = null; }

			this.metaCompare = element.getAttribute( 'meta_compare' );
			if ( _.isUndefined( this.epIntegrate ) ) { this.epIntegrate = null; }

			this.orderby = element.getAttribute( 'orderby' ) || 'date';
			this.order = element.getAttribute( 'order' ) || 'DESC';

			var self = this;

			jQuery( this.element ).click( function( e ) {
				e.preventDefault();
				self.setSpinner();
				self.fetch();
			} );

			jQuery( this.element ).on( 'loadmorepagereaset', function(){
				self.paged = 0;
			} );
			jQuery( this.element ).on( 'changepostterm', function(){
				self.terms = element.getAttribute( 'terms' );
			} );

			jQuery( this.element ).on( 'changeeventdate', function(){
				self.filterEventDate 	= element.getAttribute( 'filter_event_date' );
				self.order 				= element.getAttribute( 'order' );
			} );

			this.fetch = function( ) {
				if ( this.doingAJAX ) {
					return;
				}
				this.doingAJAX = true;
				var self = this,
					url = '/ajax-handler-request',
					action = '',
					params = {};

				if ( ! _.isUndefined( window.jdrf_ajax_handler_object ) ) {
					url = window.jdrf_ajax_handler_object.ajaxurl;
					action = window.jdrf_ajax_handler_object.action;
				}

				this.paged++;
				this.posts = {};

				/* eslint-disable */
				params = {
					action          : action,
					post_type       : this.postType,
					posts_per_page  : this.postPerPage,
					paged           : this.paged,
					post__not_in    : this.postNotIn,
					order           : this.order,
					orderby         : this.orderby,
					sites           : 'all',
					taxonomy        : this.taxonomy,
					termfield       : this.termfield,
					terms           : this.terms,
				};
				if ( null !== this.pastEvents ) {
					params.jdrf_event_past = this.pastEvents;
				}
				if ( this.hasOwnProperty( 'filterEventDate' ) ) {
					params.filter_event_date = this.filterEventDate;
				}
				if ( null !== this.epIntegrate ) {
					params.ep_integrate = this.epIntegrate;
				}
				if ( null !== this.metaKey ) {
					params.meta_key = this.metaKey;
					params.meta_value = this.metaValue;
					params.meta_compare = this.metaCompare;
				}
				/* eslint-enable */

				jQuery.ajax( {
					url  : url,
					type : 'GET',
					data : params,
				} ).done( function( result ) {
					self.clearSpinner();

					if ( ! result.success ) {
						self.doingAJAX = false;
						return;
					}

					for( var i = 0; i < result.data.posts.length; i++ ) {
						self.outputItem( result.data.posts[i] );
					}

					if ( ! result.data.more_pages ) {
						self.element.style.display = 'none';
					}
					self.doingAJAX = false;
				} );
			};

			this.outputItem = function( args ) {
				if ( _.isUndefined( this.addtoElement ) ) { return; }
				if ( _.isUndefined( this.templateElement ) ) { return; }

				var template = this.templateElement.innerHTML;
				for ( var key in args ) {
					template = template.replace( new RegExp( '{{' + key + '}}', 'g' ), args[key] );
				}

				this.addtoElement.innerHTML += template;
			};

			this.setSpinner = function() {
				if ( ! _.isUndefined( this.spinner ) ) {
					this.spinner.classList.add( 'loading-spinner' );
					this.spinner.style.display = 'inline-block';
				}
			};
			this.clearSpinner = function() {
				if ( ! _.isUndefined( this.spinner ) ) {
					this.spinner.classList.remove( 'loading-spinner' );
					this.spinner.style.display = 'none';
				}
			};
		};

		jQuery( function () {
			var loadList = [];
			var elementList = document.getElementsByClassName( 'jdrf-load-more' );

			if ( 0 < elementList.length ) {
				for ( var i = 0; i < elementList.length; i ++ ) {
					loadList.push( new loadMoreGeneric( elementList[i] ) );
				}
			}
		} );
	};

	loadMoreUtility( window.jQuery, window.Backbone, window._ );
};

export default {init};